import AnimatedImageHorizontal from 'components/AnimatedImageHorizontal/AnimatedImageHorizontal';

import { ReactComponent as ArrowRight } from 'assets/icons/arrowRight.svg';
import MediaImage from 'assets/images/media-about-us.png';

import styles from './MediaAboutUs.module.scss';
import { mediaAboutUsConfig } from './mediaAboutUs.config';

const MediaAboutUs = () => {
  const { logo, title, date, description, link, linkText } = mediaAboutUsConfig;

  return (
    <div>
      <AnimatedImageHorizontal
        src={MediaImage}
        initialDirection="left"
        speed={12}
        pauseDuration={1000}
      />
      <div className={styles.contentContainer}>
        <img
          src={logo}
          alt="BusinessWire"
          className={styles.logo}
          height={46}
        />
        <div>
          <h3 className={styles.title}>
            {title}
            <div className={styles.date}>{date}</div>
          </h3>
          <div className={styles.description}>
            <em>{description}</em>
          </div>
          <div className={styles.readMoreContainer}>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.readMore}
            >
              {linkText} <ArrowRight className={styles.arrow} />
            </a>
          </div>
        </div>
      </div>
      <AnimatedImageHorizontal
        src={MediaImage}
        initialDirection="right"
        speed={12}
        pauseDuration={1000}
        className={styles.animatedImage}
      />
    </div>
  );
};

export default MediaAboutUs;
